import { InjectionToken } from '@angular/core';
import { Auth0Config } from './auth0-types';

export interface Auth0LibConfig {
    auth0Config: Auth0Config;
    storageKey: string;
    /** Keys to remove from localStorage on logout. When omitted, all localStorage is cleared. */
    logoutStorageClear?: string[];
}

export const AUTH0_LIB_CONFIG = new InjectionToken<Auth0LibConfig>('AUTH0_LIB_CONFIG');

/** The REST API base URL used by Auth0Service for token exchange */
export const AUTH0_REST_API_URL = new InjectionToken<string>('AUTH0_REST_API_URL');
